import React from "react";

export default class TextInput extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			value: this.props.value,
		};
	}

	handleChange(event) {
		this.setState({ value: event.target.value });
		if (this.props.onChange) this.props.onChange(event.target.value);
	}

	componentDidUpdate(prevProps) {
		if (prevProps.value !== this.props.value) {
			this.setState({ value: this.props.value });
		}
	}

	render() {
		const passwordFlag = this.props.type !== undefined ? this.props.type === "password" : false;
		const readOnly = this.props.readOnly !== undefined && this.props.readOnly === true ? true : false;

		const inputStyle = {
			width: this.props.width !== undefined ? this.props.width : "300px",
			padding: "10px",
			fontFamily: "League Spartan, sans-serif",
			...this.props.style,
		};

		if (readOnly) {
			return (
				<div style={mainClass}>
					<div style={name}>{this.props.name}</div>
					<input
						type={passwordFlag ? "password" : "text"}
						style={inputTextDisabled}
						readOnly
						value={this.state.value ? this.state.value : this.props.value}
						onChange={this.handleChange.bind(this)}
					></input>
				</div>
			);
		}

		return (
			<div style={mainClass}>
				<div style={name}>{this.props.name}</div>
				<input
					type={passwordFlag ? "password" : this.props.type || "text"}
					style={inputStyle} // Applica il nuovo stile qui
					value={this.state.value !== undefined ? this.state.value : this.props.value}
					onChange={this.handleChange.bind(this)}
				></input>
			</div>
		);
	}
}

const mainClass = {
	padding: "5px",
};

const name = {};

const inputTextDisabled = {
	background: "#eeeeee",
	width: "300px",
	padding: "10px",
	fontFamily: "League Spartan, sans-serif",
};
